<template>
    <div class="referrer-third">
        <div @click="onClickCloseButton" class="left flex-row flex-wrap center">
            <i class="back-button material-icons flex-wrap">
                {{ 'close' }}
            </i>
        </div>
        <div class="question" v-html="question" />
        <!-- <div class="desc" v-html="'* 복수 선택 가능'" /> -->
        <div
            class="options"
            v-for="option in options"
            :key="option.id"
            :class="{ selected: selected === option.id }"
            @click="onClick(option.id)"
            v-html="option.title"
        ></div>
        <div class="bottom-cont">
            <div class="button" :class="{ activated: selected >= 0 }" v-html="'완료'" @click="onNext()"></div>
        </div>
    </div>
</template>

<script>
import userService from '@/services/user'

export default {
    name: 'ReferrerThirdPage',
    data: () => ({
        question:
            '외적인 매력(외모, 키, 체형 등)과 스펙(직장, 학력, 경제력 등) 중 어떤게 더 중요하신가요? (하나만 선택)',
        options: [],
        selected: -1,
    }),
    mounted() {
        this.options = (this.$store.getters.categories || []).filter(c => c.category === 'look_spec')
        // this.$nativeBridge.postMessage({
        //     action: 'sendFirebaseEvent',
        //     value: {
        //         category: 'Enter_UsedServicePage',
        //     },
        // })
    },
    beforeDestroy() {},
    methods: {
        async onClickCloseButton() {
            try {
                const idx = await this.$modal.basic({
                    body: '설문조사를 그만두시겠습니까?',
                    buttons: [
                        {
                            label: 'CANCEL',
                            class: 'btn-default',
                        },
                        {
                            label: 'CONFIRM',
                            class: 'btn-primary',
                        },
                    ],
                })
                if (idx === 1) {
                    await this.$router.push({ name: 'ChatsPage', params: { preventSetChatNull: true } })
                }
            } catch (e) {
                this.$toast.error(e.data.msg)
            }
        },
        onClick(id) {
            // if (this.selected.includes(id)) {
            //     const idx = this.selected.indexOf(id)
            //     this.selected.splice(idx, 1)
            // } else {
            //     this.selected.push(id)
            // }
            this.selected = id
        },
        async onNext() {
            if (this.selected < 0) {
                // this.$toast.error('답변을 선택해주세요!')
            } else {
                try {
                    this.$loading(true)
                    const categoryId1 = this.$route.params.category_1_id
                    const categoryId2 = this.$route.params.category_2_id
                    const categoryId3 = this.selected
                    const payload = {
                        category_1_id: categoryId1,
                        category_2_id: categoryId2,
                        category_3_id: categoryId3,
                    }
                    await userService.referrers(payload)
                    this.$toast.success('응답해주셔서 감사합니다 :)')
                    this.$router.push({ name: 'ChatsPage', params: { preventSetChatNull: true } })
                } catch (e) {
                    this.$toast.error(e.data)
                } finally {
                    this.$loading(false)
                }
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.referrer-third {
    padding-top: 24px;
    padding-bottom: 80px;

    .left {
        justify-content: flex-start;
        margin: 0 0 20px 20px;
    }

    .back-button {
        color: $grey-08;
    }

    .question {
        margin: 0 20px 8px 20px;
        font-size: 21px;
        line-height: normal;
        color: black;
        font-weight: 500;
        @include f-medium;
    }

    .desc {
        margin: 0 20px 40px 20px;
        color: $purple-primary;
        font-size: 14px;
    }

    .options {
        margin: 0 20px 12px 20px;
        height: 48px;
        line-height: 48px;
        border: solid 1px $grey-02;
        border-radius: 8px;
        font-size: 15px;
        color: $grey-09;
        padding-left: 20px;

        &.selected {
            color: $purple-primary;
            border: solid 1px $purple-primary;
        }
    }

    .bottom-cont {
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 80px;
        padding: 16px;
        border-top: solid 1px $grey-02;

        .button {
            width: 100%;
            height: 48px;
            font-size: 15px;
            text-align: center;
            line-height: 48px;
            background: $grey-02;
            color: $grey-05;
            border-radius: 8px;
            background: white;

            &.activated {
                background: $purple-primary;
                color: white;
            }
        }
    }
}
</style>
